import React from "react"

import { colors } from "@bullseye/tailwind-config"

const Facebook = () => (
  <svg
    width="32"
    height="32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Facebook"
  >
    <path
      d="M24 2.668h-4a6.667 6.667 0 00-6.666 6.667v4h-4v5.333h4v10.667h5.333V18.668h4l1.334-5.333h-5.334v-4A1.334 1.334 0 0120.001 8h4V2.668z"
      fill="#fff"
      stroke={`${colors.gray[950]}`}
    />
  </svg>
)

export default Facebook
